<template>

    <CascoAjanlatBase :titleExtra="titleExtra">

            <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatokk">

                <v-layout row wrap>

                    <BnFormField :attributes="union_casco_kotesi_ok" />
                    <BnFormField v-if="partnerszerzodesVisible" :attributes="union_casco_partnerszerzodesszam"/>
                    <BnFormField v-if="supershopVisible" :attributes="supershop"/>

                </v-layout>

            </v-form>

    </CascoAjanlatBase>

</template>

<script>
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';

export default {
    name: 'AjanlatAdatokB11_V0',
    components: { BnFormField, CascoAjanlatBase },
    mixins: [cascoOfferData],
    methods: {},
    version: 'v0',
    computed: {
        supershopVisible() {
            // ha van gfb supershop kedvezmény akkor nem kérjük, mert ott már bekérjük
            return !this.$store.getters?.kedvezmenyekbiztosito?.[this.biztositoid]?.supershop
                && +this.$store.getters.tarifaData.kock_kezd_casco < 20250601;
        },
        partnerszerzodesVisible() {
            // return !this.$store.getters?.kedvezmenyekbiztosito?.[this.biztositoid]?.supershop;
            return this.kedvezmenyek.partnerszerzodes === 'Y' || this.kedvezmenyek.partnerszerzodes === true;
        },
    },
    data() {
        return {
            union_casco_partnerszerzodesszam: {
                type: 'text',
                label: 'Union partner szerződésszám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'union_casco_partnerszerzodesszam',
                path: 'tarifaData.union_casco_partnerszerzodesszam',
            },
            supershop: {
                type: 'text',
                label: 'SuperShop kártyaszám',
                visible: true,
                editable: true,
                help: true,
                mezo: 'supershop',
                path: 'tarifaData.supershop',
                mask: '################',
            },
            union_casco_kotesi_ok: {
                type: 'select',
                label: 'Casco szerződéskötés oka',
                visible: true,
                editable: true,
                help: true,
                mezo: 'union_casco_kotesi_ok',
                path: 'tarifaData.union_casco_kotesi_ok',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 'Uj_gepjarmu', value: 'Új gépjármű' },
                    { key: 'Hasznalt_gepjarmu', value: 'Használt gépjármű' },
                    { key: 'Casco_nelkuli_hasznalt_gepjarmu', value: 'Casco nélküli használt gépjármű' },
                    { key: 'Szerzodes_atkotese_evfordulora', value: 'Szerződés átkötése évfordulóra' },
                    { key: 'DNF_miatti_megszunes', value: 'Dnf. miatti megszűnés' },
                    { key: 'Biztosito_altali_felmondas', value: 'Biztosítő általi felmondás' },
                ],
            },

        };
    },
};
</script>
